import React, {useContext} from "react";

import NotificationContext from "../contexts/notification";

const useNotification = () => useContext(NotificationContext);

export default useNotification;
